import { AudienceCreateSimplifiedPresenter } from '@/components/audiences/audience-create-simplified.presenter';
import { useCreateAudiencePage } from '@/components/audiences/use-create-audience-page';

export default function CreateAudienceSimplifiedPage() {
  const audience = useCreateAudiencePage();

  return <AudienceCreateSimplifiedPresenter {...audience} />;
}
